import moment from 'moment/moment'

import { momentBackDateFormat } from '@smartcoop/utils/dates'

export default ({ t, isBirth = false }) => YupInstance => YupInstance
  .test('date', t('invalid date'), (value) => ((!value || moment(value, momentBackDateFormat).isValid()) && (!value || (moment(value, momentBackDateFormat).isBefore(moment().add(10, 'years').format(momentBackDateFormat)) && moment(value, momentBackDateFormat, true).isAfter(moment(isBirth ? '01-01-1900' : '01-01-2000', 'DD-MM-YYYY').format(momentBackDateFormat))))))
